/**
 * @license
 * Copyright Akveo. All Rights Reserved..
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  POS_BFF_URL :"https://pos-prod-bff.irvingfund.com",
  adminURL :'https://pos-prod-ui.irvingfund.com/auth',
  pos_url :'https://pos-prod-ui.irvingfund.com',
  website :'https://irvingfund.com',

};
export const cognito = {
  userPoolId: 'us-east-1_Qq6oDW3G8',
  userPoolWebClientId : '2ctomnppu94c107s29ao27rq51',
};

